<template>
  <v-container class="px-8 py-6" fluid>
    <v-row class="ma-0">
      <slot />
    </v-row>
    <v-row class="mt-4 mx-0 mb-0">
      <v-btn :disabled="disabled" primary @click="generate">
        {{ $t('extract.buttons.generateExtract') }}
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
import clientEvents from '@enums/client-events';

export default {
  props: {
    disabled: {
      required: false,
      type: Boolean,
      default: () => false,
    },
  },

  methods: {
    generate() {
      this.$emit(clientEvents.extracts.generateExtractRequested);
    },
  },
};
</script>

<style lang="scss" scoped></style>
